<template>
  <div class="data-pages dataList">
    <p class="ptb16">门店业绩</p>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs mb10 br10">
            <div class="titles">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>业绩汇总</i></p>
              <v-date @time="change" class="ml10"></v-date> <el-select
                  v-model="query.staffId"
                  @change="selectChange"
                  class="select ml10"
                  placeholder="全部店员"
                >
                  <el-option
                    v-for="item in staffList"
                    :key="item.id"
                    :label="item.staffName"
                    :value="item.id"
                  ></el-option>
                </el-select>
            </div>
            
            <el-row class="rows">
              <el-col class="cols" :span="4">
                <p class="van-text">劳动业绩</p>
                <p class="van-label">{{amount.workAchAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售业绩</p>
                <p class="van-label">{{amount.saleAchAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总业绩</p>
                <p class="van-label">{{amount.achievementTotalAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">劳动提成</p>
                <p class="van-label">{{amount.workDeductAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售提成</p>
                <p class="van-label">{{amount.saleDeductAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总提成</p>
                <p class="van-label">{{amount.deductTotalAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">劳动社保补贴</p>
                <p class="van-label">{{amount.workSocialSubsidyAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">销售社保补贴</p>
                <p class="van-label">{{amount.saleSocialSubsidyAmount}}</p>
              </el-col>
              <el-col class="cols" :span="4">
                <p class="van-text">总社保补贴</p>
                <p class="van-label">{{amount.totalSocialSecuritySubsidy}}</p>
              </el-col>
            </el-row>
          </div>
          <div class="boxs br10">
            <div class="align-items pr16"  @click="lookList">
              <p class="order-title-boxs ptb20"><span class="blueBlock"></span><i>业绩明细</i></p>
              <p><i class="el-icon-arrow-down cur fontSize14 fb"></i></p>
            </div>
            <div class="plr16" v-if="listFlag">
              <el-table :data="list" :max-height="height - 580" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="itemName" label="服务名称"></el-table-column>
                <el-table-column prop="achieveType" label="类型">
                  <template slot-scope="scope">
                    <span class="van-text" v-if="scope.row.achieveType == 'invalid'">作废</span>
                    <span style="color: #ff892a;" v-if="scope.row.achieveType == 'refund'">退款</span>
                    <span style="color: #ee2e2e;" v-if="scope.row.achieveType == 'order'">开单</span>
                    <span style="color: #ff892a;" v-if="scope.row.achieveType == 'distribution'">分配</span>
                  </template>
                </el-table-column>
                <el-table-column prop="staffIdCn" label="店员姓名"></el-table-column>
                <el-table-column prop="maxMoneyPreMonth" label="业绩">
                  <template slot-scope="scope">
                    <p
                      class="van-text"
                      v-if="scope.row.achievementTotalAmount>=0"
                    >￥{{ scope.row.achievementTotalAmount }}</p>
                    <p
                      class="primary-color"
                      style="color: #02c346;"
                      v-else
                    >￥{{ scope.row.achievementTotalAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="maxMoneyPreMonth" label="提成">
                  <template slot-scope="scope">
                    <p
                      class="van-text"
                      v-if="scope.row.deductTotalAmount>=0"
                    >￥{{ scope.row.deductTotalAmount }}</p>
                    <p
                      class="primary-color"
                      style="color: #02c346;"
                      v-else
                    >￥{{ scope.row.deductTotalAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="socialSubsidyTotalAmount" label="社保补贴">
                  <template slot-scope="scope">
                    <p class="van-text">￥{{ scope.row.socialSubsidyTotalAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="oxCtime" label="创建时间" min-width="150px">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
                </el-table-column>
                <!-- <el-table-column prop="itemName" label="支付方式">
                  <template slot-scope="scope">
                    {{scope.row.payWay == 'cash' ? '现金': '会员'}}
                  </template>
                </el-table-column> -->
                <el-table-column prop="payWayCn" label="支付方式">
                </el-table-column>
                <el-table-column prop="amt" label="操作" align="center" width="180" fixed="right">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="detailPage(scope.row)">查看详情</el-link>
                  </template>
                </el-table-column>
              </el-table>
              <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
            </div>
          </div>
        </div>
      </div>
      <edit-set ref="editForm"></edit-set>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "../../orderInfo/edit.vue";
export default {
  mixins: [minxin],
  components: { editSet },
  data() {
    return {
      staffList: [],
      downloadUrl: require("../../../assets/images/home/data.png"),
      amount: {
        itemName: "",
        itemNum: "",
        saleAmount: "", //销售业绩
        saleDeductAmount: "",
        workAmount: "", //劳动
        workDeductAmount: ""
      },
      url: this.$url.orderAchievement.list,
      query: {
        staffId: "",
        beginTime: new Date(),
        endTime: new Date()
      },
      listFlag: false,
      height: this.$store.getters.MainHeight,
      totalCount: 0
    };
  },

  created() {
    this.companyStaffList();
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.$route.meta.title != "订单明细") {
      sessionStorage.removeItem("beginTime");
      sessionStorage.removeItem("endTime");
    }
  },
  methods: {
    back() {
      this.$router.push('/dataList');
    },
    change(value) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
      this.listFlag = false;
      this.list = [];
      this.init();
    },
    selectChange(org) {
      this.query.start = 1;
      this.totalCount = 0;
      this.query.staffId = org;
      this.listFlag = false;
      this.list = [];
      this.init();
    },
    companyStaffList() {
      this.$api.post(this.$url.companyStaff.listAuthForData).then(res => {
        this.staffList = res;
      }).catch(error => {});
    },
    totalCounts () {
      this.totalCount = 0;
      this.$api.post(this.$url.orderAchievement.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    init() {
      this.$api.post(this.$url.orderAchievement.sumByShop, this.query).then(res => {
        if (res) {
          this.amount = res;
        }
      });
    },
    lookList () {
		this.listFlag = !this.listFlag;
      // 查看列表
      if (this.listFlag) {
        this.totalCounts();
      }
    },
    detailPage(item) {
      this.$refs["editForm"].$emit("set", { orderId: item.orderId, source: 'achievement' });
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
* {
  box-sizing: border-box;
}
.page-head {
  height: 100%;
}

.mains-content {
  height: calc(100% - 72px)
}
.boxs {
  background: #fff;
  .titles {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
}
</style>